import { Box, Chip } from "@mui/material";
import { type GridColDef } from "@mui/x-data-grid";
import parse from "html-react-parser";

import { type Artifact } from "./AllArtifacts.data";

export const getArtifactsColumns = (
  onActionClick: (_number: number) => void,
): GridColDef<Artifact>[] => [
  {
    field: "artifact",
    headerName: "Artifact",
    width: 100,
  },
  {
    field: "description",
    headerName: "Artifact Description",
    flex: 1,
    minWidth: 300,
    sortable: false,
    renderCell: ({ row }) => (
      <Box sx={{ whiteSpace: "normal", lineHeight: 1.5, py: 1 }}>
        {parse(row.description)}
      </Box>
    ),
  },
  {
    field: "actions",
    headerName: "Related Actions, Artifacts, Decisions",
    width: 280,
    sortable: false,
    renderCell: ({ row }) => (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 1 }}>
        {row.actions?.map((number) => (
          <Chip
            key={number}
            variant="outlined"
            color="primary"
            size="small"
            sx={{ minWidth: 25, p: 0 }}
            label={number}
            onClick={() => onActionClick(number)}
          />
        ))}
      </Box>
    ),
  },
];
